/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ContainerFindingDockleSummary {
    getFixupPrototypeFunction() { return ContainerFindingDockleSummary.fixupPrototype; }

    static newInstance(model: Partial<ContainerFindingDockleSummary>): ContainerFindingDockleSummary {
        let obj = Object.assign(new ContainerFindingDockleSummary(), model);
        ContainerFindingDockleSummary.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ContainerFindingDockleSummary>): ContainerFindingDockleSummary {
        if (!model) return null;
        return ContainerFindingDockleSummary.newInstance(<ContainerFindingDockleSummary> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ContainerFindingDockleSummary) {
        if (!obj) return;

        models.ContainerFindingDockleSummary.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ContainerFindingDockleSummary): boolean {
        Object.setPrototypeOf(obj, ContainerFindingDockleSummary.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.fatal === undefined) {
            this.fatal = 0;
        }
        if (this.warn === undefined) {
            this.warn = 0;
        }
        if (this.info === undefined) {
            this.info = 0;
        }
        if (this.skip === undefined) {
            this.skip = 0;
        }
        if (this.pass === undefined) {
            this.pass = 0;
        }
    }

    /**
     * Total number of fatal security issues found by Dockle that must be addressed
     */
    fatal: number;

    /**
     * Total number of warning-level security issues found by Dockle that should be reviewed
     */
    warn: number;

    /**
     * Total number of informational security issues found by Dockle for awareness
     */
    info: number;

    /**
     * Total number of security checks that were skipped during the Dockle scan
     */
    skip: number;

    /**
     * Total number of security checks that passed successfully during the Dockle scan
     */
    pass: number;

}
